import { createFileRoute } from "@tanstack/react-router";
import { BrasilChannelLanding } from "@/components/match/brasil/BrasilChannelLanding";
import { BRASIL_FAQ_BY_CHANNEL, buildFaqJsonLd } from "@/components/growth/BrasilFaq";

export const Route = createFileRoute("/brasil/sportv")({
  head: () => ({
    meta: [
      { title: "VerseSport Brasil + SporTV — Estatísticas ao vivo" },
      { name: "description", content: "Combine a transmissão da SporTV com previsões em tempo real, Nation Wars e Audio Sync no VerseSport." },
      { property: "og:title", content: "VerseSport Brasil + SporTV — Estatísticas ao vivo" },
      { property: "og:description", content: "Combine a transmissão da SporTV com previsões em tempo real, Nation Wars e Audio Sync no VerseSport." },
      { property: "og:url", content: "https://versesport.com/brasil/sportv" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/brasil/sportv" }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(buildFaqJsonLd(BRASIL_FAQ_BY_CHANNEL.sportv)) }],
  }),
  component: () => (
    <BrasilChannelLanding channelId="sportv" channelName="SporTV" intro="Estatísticas avançadas e previsões em tempo real para quem assiste à SporTV." />
  ),
});
